import { render, staticRenderFns } from "./GroupProfile.vue?vue&type=template&id=d3f71032&scoped=true&"
import script from "./GroupProfile.vue?vue&type=script&lang=ts&"
export * from "./GroupProfile.vue?vue&type=script&lang=ts&"
import style0 from "./GroupProfile.vue?vue&type=style&index=0&id=d3f71032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f71032",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VRow,VSpacer,VTextField})
